import React from 'react';
import { TrophyIcon, GlobeIcon } from 'lucide-react';
import { CtaBlock } from './CtaBlock';
const rows = [{
  label: '6 Meister-Handbücher zum Nachschlagen',
  value: '492 €'
}, {
  label: '5 exklusive Boni',
  value: '245 €'
}];
export function Offer() {
  return <section id="angebot" className="border-t border-ink-700 bg-ink-900 px-4 py-12 sm:px-6 sm:py-16" data-id="element-188" data-mp="1mpd502cnhx6e">
      <div className="mx-auto w-full max-w-2xl" data-id="element-189" data-mp="tylbjcmyzmmr">
        <div className="text-center" data-id="element-190" data-mp="tzd74ngkhkd1">
          <div className="mx-auto mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-brand/15" data-id="element-191" data-mp="ozs1ju6w6drc">
            <TrophyIcon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-192" data-mp="13wrgy47zjawd" />
          </div>
          <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-brand" data-id="element-193" data-mp="yxy2o9kvjfv5">
            Besonderes Einführungsangebot
          </p>
          <h2 className="mt-2 font-display text-[26px] uppercase leading-[1.1] text-white sm:text-4xl" data-id="element-194" data-mp="2fav68x3moav3">
            Alles, was du heute erhältst
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-2xl border-2 border-brand/60 bg-ink-800" data-id="element-195" data-mp="pkqpof5323ce">
          <div className="divide-y divide-ink-700" data-id="element-196" data-mp="uisfdix0l0wu">
            {rows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 px-4 py-3.5" data-id="element-197" data-mp="ziob6uvk5m1b">
                <span className="text-[15px] text-white/80" data-id="element-198" data-mp="13jqafbph5y3a">{row.label}</span>
                <span className="shrink-0 font-semibold text-white/60 line-through" data-id="element-199" data-mp="13hnmcx7vuf17">
                  {row.value}
                </span>
              </div>)}
            <div className="flex items-center justify-between gap-4 bg-ink-700/60 px-4 py-3.5" data-id="element-200" data-mp="btc0fqkl15ww">
              <span className="font-display text-sm uppercase tracking-wide text-white" data-id="element-201" data-mp="fsupmyjfs35j">
                Gesamtwert des Systems
              </span>
              <span className="shrink-0 font-display text-xl text-white/70 line-through" data-id="element-202" data-mp="3k8vqkgpyi87q">737 €</span>
            </div>
          </div>

          <div className="px-4 py-7 text-center" data-id="element-203" data-mp="3o8wi9322gfwq">
            <p className="text-sm text-white/60" data-id="element-204" data-mp="vfqxu4aubgt9">Aber heute zahlst du keine 737 €…</p>
            <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.2em] text-brand" data-id="element-205" data-mp="vdnzmwzjahdg">
              Erhalte heute Zugang für nur
            </p>
            <p className="mt-1 font-display text-6xl leading-none text-brand sm:text-7xl" data-id="element-206" data-mp="154ij5tleb2v7">19,00 €</p>

            <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-xs font-medium text-white/70 sm:text-sm" data-id="element-207" data-mp="107iffpc0qc79">
              {['Einmalige Zahlung', 'Keine Abonnements', 'Sofortiger Zugang', 'Lebenslanger Zugang'].map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-208" data-mp="li2reh3vgkv9">
                    <span className="text-brand" aria-hidden="true" data-id="element-209" data-mp="hfzbnga66u46">
                      ✓
                    </span>
                    {item}
                  </li>)}
            </ul>

            <CtaBlock label="Zugang für 19 € freischalten" className="mt-6" data-id="element-210" data-mp="1svegf68meq9u" />

            <div className="mt-6 flex items-start gap-2.5 rounded-xl border border-ink-600 bg-ink-900 p-3 text-left" data-id="element-211" data-mp="1sxhac1cw93ju">
              <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-212" data-mp="25dgtk06m31lv" />
              <p className="text-xs leading-relaxed text-white/65" data-id="element-213" data-mp="1qgpsznl7bjuo">
                Die Währungsumrechnung erfolgt <strong className="text-white" data-id="element-214" data-mp="1vfatzp8a27k6">automatisch</strong>. Du
                zahlst den entsprechenden Betrag in deiner lokalen Währung.
              </p>
            </div>
          </div>
        </div>

        <p className="mt-5 text-center text-sm leading-relaxed text-white/60" data-id="element-215" data-mp="2o4riibss14b4">
          Weniger als viele kleine Werkstattkosten – und ein Werkzeug, das du noch jahrelang nutzen
          kannst.
        </p>
      </div>
    </section>;
}